"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _defineType = require("../_util/defineType");
var _jsxRuntime = require("react/jsx-runtime");
const Elevation = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    type = 1,
    shadow = false,
    borderRadius,
    padding,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-elevation");
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ...restProps,
    ref: ref,
    className: (0, _classnames.default)(baseClassName, "".concat(baseClassName, "--type-").concat(type), "".concat(baseClassName, "--shadow-").concat(typeof shadow === 'boolean' ? shadow ? type : 'none' : shadow), {
      ["".concat(baseClassName, "--padding-").concat(padding)]: typeof padding === 'string',
      ["".concat(baseClassName, "--radius")]: borderRadius !== false
    }, className),
    style: {
      padding: typeof padding === 'number' ? padding : undefined,
      borderTopLeftRadius: (0, _defineType.isObject)(borderRadius) ? borderRadius.topLeft : undefined,
      borderTopRightRadius: (0, _defineType.isObject)(borderRadius) ? borderRadius.topRight : undefined,
      borderBottomLeftRadius: (0, _defineType.isObject)(borderRadius) ? borderRadius.bottomLeft : undefined,
      borderBottomRightRadius: (0, _defineType.isObject)(borderRadius) ? borderRadius.bottomRight : undefined,
      ...style
    },
    children: children
  });
});
var _default = exports.default = Elevation;